import { actionNames, actionPrefixes, objectTypes } from "@newsela/snitch";

import ExportablesBaseModal from "@/components/AIComponents/ExportablesModal/ExportablesBaseModal";
import { useExportablesContext } from "@/components/AIComponents/ExportablesModal/ExportablesContextProvider/useExportablesContext";
import {
  activityInfoContentCss,
  iconCss,
} from "@/view/ArticleActivityPicker/ArticleActivityPicker.style";
import ArticleActivityPickerOption from "@/view/ArticleActivityPicker/ArticleActivityPickerOption";
import activityTypes from "@/view/constants/activityTypes";

const StudentComponent = () => {
  const Icon = activityTypes.GRAPHIC_ORGANIZERS.icon;

  const {
    content,
    isContentSupported,
    handleTemplateSelection,
    isInAssignGraphicOrganizersExperiment,
    levelId,
    modalTriggerRef,
  } = useExportablesContext();

  const eventProperties = {
    objectType: objectTypes.graphicOrganizer,
    actionPrefix: actionPrefixes.initiate,
    actionName: actionNames.interact,
    dataProps: { "data-qa-selector": "open-exportables-modal-button" },
    ref: modalTriggerRef,
    streamProperties: {
      content_type: content.content_type,
      content_id: levelId,
      description: "Open modal for exportable resources",
    },
  };

  const handleClick = () => {
    handleTemplateSelection();
  };

  if (!isContentSupported || !isInAssignGraphicOrganizersExperiment)
    return null;

  return (
    <>
      <ArticleActivityPickerOption
        onClick={handleClick}
        eventProperties={eventProperties}
      >
        <span css={activityInfoContentCss}>
          <Icon css={iconCss({ isPowerWord: false })} />
          {activityTypes.GRAPHIC_ORGANIZERS.label}
        </span>
      </ArticleActivityPickerOption>

      <ExportablesBaseModal isStudent />
    </>
  );
};

export default StudentComponent;
